module.exports = __webpack_public_path__ + "img/cuisine.f6bc3050.jpg";